import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/**
 * Route guard — anything wrapped in this must be entered via the Threshold.
 * Allows any authenticated role (visitor, admin, master). Public Witness mode
 * has been retired: the entire site sits behind the gate.
 */
export default function RequireAuth({ children }) {
  const { user, isAuthenticated } = useAuth();
  const location = useLocation();

  // Auth is still resolving — render nothing (prevents flicker/redirect race)
  if (user === null) return null;

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/threshold"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }
  return children;
}
